import { render, staticRenderFns } from "./HomeLayoutMain.vue?vue&type=template&id=6679b710&scoped=true"
import script from "./HomeLayoutMain.vue?vue&type=script&lang=js"
export * from "./HomeLayoutMain.vue?vue&type=script&lang=js"
import style0 from "./HomeLayoutMain.vue?vue&type=style&index=0&id=6679b710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679b710",
  null
  
)

export default component.exports